import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

const Robustand = () => {
  return (
    <div className="Robustand p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
            <h2>Our Robust Magento Development Services</h2>
            <p>
              Tekrevol specializes in enhancing e-commerce excellence through
              Custom Magento development services. With a dedicated team of
              Magento ecommerce developers, we ensure their expertise is
              leveraged to create tailored solutions, elevating your online
              business presence. Here are the revolutionary services that we
              offer:{" "}
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Let’s Build Your Magento Website
            </Link>
          </Col>
          <Col xs={12} md={6} lg={7} xl={6} xxl={6} className="offset-xl-1">
            <div className="robustscroll">
              <div className="robust-box">
                <div className="robust-content">
                  <h4>Custom Magento Development</h4>
                  <p>
                    Our Custom Magento development delivers unique solutions,
                    precisely addressing your business challenges. Utilizing
                    their expertise, our Magento 2 developers create a bespoke
                    solution designed explicitly for your enterprise. Focused on
                    scalability and user-centric design, we ensure seamless
                    interfaces and ongoing support, empowering your thriving
                    online presence.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Magento Marketplace Development</h4>
                  <p>
                    As an expert Magento 2 Development Company, TekRevol
                    specializes in creating expansive and versatile online
                    platforms. With our dedicated expertise in Magento, we
                    carefully engineer dynamic marketplaces where multiple
                    vendors converge to offer their diverse array of products
                    and services seamlessly. Our approach prioritizes
                    scalability, customization, and user-centric design,
                    ensuring an intuitive experience.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Magento 2 Theme Development</h4>
                  <p>
                    As a top-rated Magento website development company, Tekrevol
                    is an expert in Magento 2 Theme Development. Therefore, we
                    design and develop visually appealing, user-friendly themes
                    and templates that redefine online aesthetics. These themes
                    are tailored to align with brand aesthetics, ensuring a
                    captivating and engaging user interface that increases
                    customer interaction and drives conversions.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Magento Migration Services</h4>
                  <p>
                    We empower businesses through seamless migration processes,
                    whether transitioning from older Magento versions or other
                    platforms to the latest Magento or Magento 2 versions. This
                    service ensures data integrity, functionality preservation,
                    and minimal disruption to ongoing operations. It enables you
                    to manage the reliability of your platform while making any
                    update to ensure its compatibility.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Magento B2B Development</h4>
                  <p>
                    We offer tailored solutions specifically designed to meet
                    the unique requirements of B2B e-commerce. Leveraging our
                    profound expertise in Magento, we engineer comprehensive B2B
                    solutions that optimize transactions. As a result, our
                    service enables custom pricing structures, facilitates bulk
                    orders, and empowers personalized account management while
                    ensuring the credibility of your business.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Magento 2 React Development</h4>
                  <p>
                    We specialize in Magento 2 React Development, combining the
                    robustness of Magento with the versatility of React to craft
                    dynamic e-commerce solutions. We expertly integrate React
                    components within Magento 2, optimizing user interfaces for
                    enhanced interactivity. Our focus lies in building
                    responsive, engaging platforms that offer seamless
                    navigation and lifted user experiences.
                  </p>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Robustand;
